<template>
  <generic-container
    class="ui tab segment"
    data-tab="business_objects"
    :title="$t('business objects')"
    icon="cubes"
    :show_plus="true"
    :searchable="true"
    v-on:add="add"
    @filter="filter"
  >
    <div class="ui selection divided list">
      <div
        class="item"
        v-for="(item, index) in $props.project.setup.business_objects"
        :key="index"
        v-on:click.stop="edit(item, index)"
      >
        <div class="right floated buttons">
          <div
            class="ui button red icon mini labeled"
            v-on:click.stop="remove(item, index)"
          >
            <i class="trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
        <img class="ui avatar image" src="/images/icons/object.png" />
        <div class="content">
          <a class="header">{{ item.name }}</a>
          <div class="description">{{ item.description }}</div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
        :business_object="selected_business_object"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import BusinessObjectModal from "./BusinessObjectModal";
import filters from "@/filters";

export default {
  name: "BusinessObjectManagement",
  filters: filters,
  props: { project: Object },
  components: {
    GenericContainer
  },
  data() {
    return {
      popup_modals: [],
      all_business_objects: [],
      selected_business_object: {}
    };
  },
  methods: {
    add() {
      this.popup_modals.push(BusinessObjectModal);
    },
    remove(ht, index) {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove business object?"),
        function() {
          vm.$props.project.setup.business_objects.splice(index, 1);
        }
      );
    },
    edit(bo) {
      this.selected_business_object = bo;
      this.popup_modals.push(BusinessObjectModal);
    },
    succedded(bo) {
      let vm = this;
      let trgt = vm.$props.project.setup.business_objects.findIndex(
        (n) => n.uuid == bo.uuid
      );
      if (trgt != -1)
        vm.$props.project.setup.business_objects.splice(trgt, 1, bo);
      else vm.$props.project.setup.business_objects.push(bo);
    },
    destroy() {
      this.popup_modals = [];
      this.selected_business_object = {};
    },
    filter(query) {
      if (!query)
        this.$props.project.setup.business_objects = this.all_business_objects;
      else
        this.$props.project.setup.business_objects = this.all_business_objects.filter(
          (n) =>
            n.name.toUpperCase().includes(query.toUpperCase()) ||
            n.description.toUpperCase().includes(query.toUpperCase())
        );
    }
  },
  mounted() {
    let vm = this;
    setTimeout(function() {
      vm.$props.project.setup.business_objects =
        vm.$props.project.setup.business_objects || [];
      vm.all_business_objects = [...vm.$props.project.setup.business_objects];
    }, 500);
  },
  watch: {
    // business_objects() {
    //   this.$props.project.setup.business_objects = this.business_objects;
    // }
  }
};
</script>
